var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhotoWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 7.99998C1.59998 9.69736 2.27426 11.3252 3.47449 12.5255C4.67473 13.7257 6.30259 14.4 7.99998 14.4C9.69736 14.4 11.3252 13.7257 12.5255 12.5255C13.7257 11.3252 14.4 9.69736 14.4 7.99998C14.4 6.30259 13.7257 4.67473 12.5255 3.47449C11.3252 2.27426 9.69736 1.59998 7.99998 1.59998C6.30259 1.59998 4.67473 2.27426 3.47449 3.47449C2.27426 4.67473 1.59998 6.30259 1.59998 7.99998Z",
    fill: "#F24F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07089 3.96118C8.40226 3.96118 8.67089 4.22981 8.67089 4.56118V7.14601C8.67089 7.47738 8.40226 7.74601 8.07089 7.74601C7.73952 7.74601 7.47089 7.47738 7.47089 7.14601V4.56118C7.47089 4.22981 7.73952 3.96118 8.07089 3.96118Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45507 9.11504C7.61837 8.95173 7.83987 8.85999 8.07082 8.85999C8.30177 8.85999 8.52326 8.95173 8.68657 9.11504C8.84988 9.27835 8.94162 9.49984 8.94162 9.73079C8.94162 9.96174 8.84988 10.1832 8.68657 10.3465C8.52326 10.5099 8.30177 10.6016 8.07082 10.6016C7.83987 10.6016 7.61837 10.5099 7.45507 10.3465C7.29176 10.1832 7.20001 9.96174 7.20001 9.73079C7.20001 9.49984 7.29176 9.27835 7.45507 9.11504ZM8.07082 9.73999C8.07325 9.73999 8.07559 9.73902 8.07732 9.73729C8.07904 9.73557 8.08001 9.73323 8.08001 9.73079C8.08001 9.72835 8.07904 9.72601 8.07732 9.72429C8.07559 9.72256 8.07325 9.72159 8.07082 9.72159C8.06838 9.72159 8.06604 9.72256 8.06431 9.72429C8.06259 9.72601 8.06162 9.72835 8.06162 9.73079C8.06162 9.73323 8.06259 9.73557 8.06431 9.73729C8.06604 9.73902 8.06838 9.73999 8.07082 9.73999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoWarning);
export default __webpack_public_path__ + "static/media/photo-warning.69a0a76c.svg";
export { ForwardRef as ReactComponent };